"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeJsonStringify = exports.safeJsonParse = void 0;
const tslib_1 = require("tslib");
const safeJsonUtils = tslib_1.__importStar(require("safe-json-utils"));
exports.safeJsonParse = safeJsonUtils.safeJsonParse;
exports.safeJsonStringify = safeJsonUtils.safeJsonStringify;
//# sourceMappingURL=json.js.map